import React, { useContext, useRef, useState } from 'react';
import { each, find } from 'lodash';
import cn from "classnames";
import SvgIcon from '../../../../../../common/components/svg-icon';
import { FocusBaseContext } from '../../../contexts';
import {
  checkResult,
  checkTimeout,
  createSummary, updateSummary
} from '../../../../../../express/researcher/common/summary-panel/http-helpers';
import Http from '../../../../../../common/http';
import SummaryEditor from '../../../../../../express/researcher/common/summaryPanelWithEditing/summaryEditor';
import WithData from './withData';
import NoData from './noData';

const Reaction = ({ title, fullTitle, conceptId, tag, region }) => {
  const { aiSummaries, setAiSummaries, project, currentSummary } = useContext(FocusBaseContext);

  const [ working, setWorking ] = useState(false);
  const [ disabled, setDisabled ] = useState(false);
  const [ showModalForm, setShowModalForm ] = useState(false);

  const [ attempt, setAttempt ] = useState(0);
  const attemptRef = useRef(attempt);
  attemptRef.current = attempt;

  const summariesRef = useRef(aiSummaries);
  summariesRef.current = aiSummaries;

  const summary = find(aiSummaries, (el) => (
    el.source_id === conceptId && el.source_type === 'Focus::Concept' && el.tag === tag
  ));

  const inProgress = working || !!summary && !!summary.jid;

  const runAI = () => {
    setWorking(true);
    setAttempt(0);

    createSummary(
      {
        project_id: project.id,
        source_id: conceptId,
        source_type: 'Focus::Concept',
        tag
      },
      (http) => {
        setTimeout(() => {
          checkResult(
            [ http.data ],
            setAttempt, attemptRef, summariesRef, setAiSummaries, setWorking,
            { useRefSummary: true, unlimitedMaxAttempts: true }
          );
        }, checkTimeout);
      },
      () => {setWorking(false);},
      { concept_region_id: region?.id, filter: currentSummary.filter }
    );
  };

  const update = (params) => {
    setDisabled(true);
    Http.put(`/express/api/ai_summaries/${summary.id}`, params).then(
      (http) => {
        if (http.response.status === 200) {
          if (showModalForm) {
            setShowModalForm(false);
          }
          if ('summary' in params) {
            summary.summary = params.summary;
          }
          if ('add_to_report' in params) {
            summary.add_to_report = params.add_to_report;
          }
          if ('raw_data' in params) {
            summary.raw_data = http.data.record.raw_data;
            summary.raw_data_hashes = http.data.record.raw_data_hashes;
          }
          summary.edited_at_by = http.data.record.edited_at_by;
          setAiSummaries([ ...aiSummaries ]);
        }
        setDisabled(false);
      },
      (reject) => {
        console.log('something went wrong', reject);
      }
    );
  };

  const handleUpdateSummary = () => {
    setWorking(true);
    setAttempt(0);

    updateSummary(
      summary.id,
      (http) => {
        setTimeout(() => {
          checkResult(
            [ http.data ],
            setAttempt, attemptRef, aiSummaries, setAiSummaries, setWorking,
            { unlimitedMaxAttempts: true }
          );
        }, checkTimeout);
      },
      () => {setWorking(false);},
      { filter: currentSummary.filter }
    );
  };

  const handleEditClick = () => {
    setShowModalForm(true);
  };

  const cancelModal = () => {
    setShowModalForm(false);
  };

  const saveModalData = (newSummary) => {
    const result = {};
    each(newSummary, (el, index) => {
      result[index] = JSON.stringify(el);
    });

    update({ raw_data: result });
  };

  const componentTitle = (fullTitle ? fullTitle : `BuzzIQ Summary - ${title}`);

  return (
    <li>
      { inProgress && <NoData title={ componentTitle } text="Working ..." />}

      { !inProgress && !summary &&
        <>
          <NoData title={ componentTitle } text={ 'Summary was not created yet' } />
          <div className="buttons">
            <a className={ cn("link", tag) } onClick={ runAI }>
              <SvgIcon name="refresh" />
              Create Summary
            </a>
          </div>
        </>}

      { !inProgress && summary &&
        <WithData
          title={ componentTitle }
          summary={ summary }
          onChangeAddToReport={ (v) => {update({ add_to_report: v });} }
          handleUpdateSummary={ handleUpdateSummary }
          handleEditClick={ handleEditClick }
          disabled={ disabled }
          region={ region }
        />}

      {
        showModalForm &&
        <SummaryEditor
          cancelModal={ cancelModal }
          saveModalData={ saveModalData }
          disabled={ disabled }
          summaryDataInit={ summary.raw_data }
          deleteClassName="-danger"
        />
      }
    </li>
  );
};

export default Reaction;
